(function () {
  if (window.__kThemeCartSkuQuickShopBooted) return;
  window.__kThemeCartSkuQuickShopBooted = true;

  var activeItem = null;

  function getCartItem(lineKey) {
    return (window.KThemeCartSkuUpdateItems || {})[lineKey] || null;
  }

  function getModal(productId) {
    return document.getElementById("QuickShopModal-" + productId);
  }

  function setStatus(productId, options) {
    if (window.theme && typeof theme.setQuickShopModalStatus === "function") {
      theme.setQuickShopModalStatus(productId, options);
    }
  }

  function openModal(item, sourceEl) {
    var modal = getModal(item.productId);
    if (!modal || !window.theme || typeof theme.ensureQuickShopModal !== "function") {
      window.location.href = "/products/" + item.handle;
      return;
    }

    activeItem = item;
    modal.classList.add("modal--cart-sku-update");
    modal.dataset.cartLineKey = item.key;
    document.addEventListener("modalClose.QuickShopModal-" + item.productId, function () {
      cleanupCartUpdateModal(modal);
    }, { once: true });

    var modalInstance = theme.ensureQuickShopModal(item.productId);
    setStatus(item.productId, {
      loading: true,
      error: false,
      text: "Loading product details..."
    });

    if (modalInstance) {
      modalInstance.open();
    }

    var preload = typeof theme.preloadProductModal === "function"
      ? theme.preloadProductModal(item.handle, item.productId, sourceEl)
      : Promise.resolve();

    preload
      .then(function () {
        configureCartUpdateModal(modal, item);
        setStatus(item.productId, {
          loading: false,
          error: false
        });
      })
      .catch(function () {
        setStatus(item.productId, {
          error: true,
          text: "Unable to load product details. Please try again."
        });
      });
  }

  function configureCartUpdateModal(modal, item) {
    var form = modal.querySelector(".product-single__form");
    if (!form) return;

    form.dataset.cartSkuUpdate = "1";
    form.dataset.cartLineKey = item.key;

    hideExtraButtons(form);
    setButtonText(form, "UPDATE");
    setFormQuantity(form, item.quantity);
    selectVariant(form, item.variantId);
  }

  function cleanupCartUpdateModal(modal) {
    var form = modal.querySelector(".product-single__form");
    modal.classList.remove("modal--cart-sku-update");
    delete modal.dataset.cartLineKey;

    if (form) {
      delete form.dataset.cartSkuUpdate;
      delete form.dataset.cartLineKey;
      restoreCartUpdateForm(form);
    }

    activeItem = null;
  }

  function restoreCartUpdateForm(form) {
    form.querySelectorAll("[data-cart-original-display]").forEach(function (el) {
      el.style.display = el.dataset.cartOriginalDisplay;
      delete el.dataset.cartOriginalDisplay;
    });

    form.querySelectorAll("[data-cart-original-text]").forEach(function (el) {
      el.textContent = el.dataset.cartOriginalText;
      el.dataset.defaultText = el.dataset.cartOriginalDefaultText || el.dataset.defaultText || "";
      delete el.dataset.cartOriginalText;
      delete el.dataset.cartOriginalDefaultText;
    });
  }

  function hideExtraButtons(form) {
    form.querySelectorAll(".pbg-right, .add-to-buy, .shopify-payment-button").forEach(function (el) {
      var wrap = el.closest(".btns") || el;
      if (typeof wrap.dataset.cartOriginalDisplay === "undefined") {
        wrap.dataset.cartOriginalDisplay = wrap.style.display || "";
      }
      wrap.style.display = "none";
    });

    form.querySelectorAll(".product__quantity").forEach(function (el) {
      if (typeof el.dataset.cartOriginalDisplay === "undefined") {
        el.dataset.cartOriginalDisplay = el.style.display || "";
      }
      el.style.display = "none";
    });
  }

  function setButtonText(form, text) {
    form.querySelectorAll('[id^="AddToCartText-"]').forEach(function (el) {
      if (typeof el.dataset.cartOriginalText === "undefined") {
        el.dataset.cartOriginalText = el.textContent;
      }
      if (typeof el.dataset.cartOriginalDefaultText === "undefined") {
        el.dataset.cartOriginalDefaultText = el.dataset.defaultText || "";
      }
      el.textContent = text;
      el.dataset.defaultText = text;
    });
  }

  function closeModal(productId) {
    var modal = getModal(productId);
    var modalInstance = modal && modal._quickShopModalInstance;

    if (modalInstance && typeof modalInstance.close === "function") {
      modalInstance.close();
    }
  }

  function setFormQuantity(form, quantity) {
    form.querySelectorAll('[name="quantity"]').forEach(function (input) {
      input.value = quantity || 1;
    });
  }

  function getVariantFromForm(form, variantId) {
    var productSection = form.closest(".product-section");
    var productJson = productSection && productSection.querySelector(
      'script[type="application/json"][data-quick-shop-product-json]'
    );
    if (!productJson || !productJson.textContent) return null;

    try {
      var product = JSON.parse(productJson.textContent);
      return (product.variants || []).find(function (variant) {
        return String(variant.id) === String(variantId);
      }) || null;
    } catch (e) {
      return null;
    }
  }

  function selectVariant(form, variantId) {
    var variant = getVariantFromForm(form, variantId);
    if (!variant) return;

    var optionValues = [variant.option1, variant.option2, variant.option3].filter(Boolean);

    form.querySelectorAll(".variant-input-wrap").forEach(function (wrap, index) {
      var value = optionValues[index];
      if (!value) return;

      var radio = wrap.querySelector('input[type="radio"][value="' + cssEscape(value) + '"]');
      if (radio && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event("change", { bubbles: true }));
      }

      var select = wrap.querySelector("select");
      if (select && select.value !== value) {
        select.value = value;
        select.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });

    var masterSelect = form.querySelector('[name="id"]');
    if (masterSelect) {
      masterSelect.value = variantId;
      masterSelect.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  function cssEscape(value) {
    if (window.CSS && typeof CSS.escape === "function") {
      return CSS.escape(String(value));
    }
    return String(value).replace(/"/g, '\\"');
  }

  function showFormError(form, message) {
    var existing = form.querySelector(".errors");
    if (existing) existing.remove();

    var error = document.createElement("div");
    error.className = "errors text-center";
    error.textContent = message;
    form.appendChild(error);
  }

  function fetchJson(url, payload) {
    return fetch(url, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify(payload)
    }).then(function (response) {
      return response.json().then(function (json) {
        if (!response.ok || json.status === 422) {
          throw json;
        }
        return json;
      });
    });
  }

  function buildAddPayload(item, variantId) {
    var payload = {
      id: Number(variantId),
      quantity: Number(item.quantity) || 1
    };

    if (item.properties && Object.keys(item.properties).length) {
      payload.properties = item.properties;
    }

    if (item.sellingPlan) {
      payload.selling_plan = item.sellingPlan;
    }

    return payload;
  }

  function getSubmitButton(form) {
    var buttons = Array.prototype.slice.call(form.querySelectorAll('button[name="add"], button.add-to-cart'));
    return buttons.find(function (button) {
      return button.offsetParent !== null;
    }) || buttons[0] || null;
  }

  function setSubmitLoading(button, isLoading) {
    if (!button) return;

    var loadingTarget = button.classList.contains("btns")
      ? button.querySelector(".add-to-cart") || button
      : button;

    button.classList.remove("btn--loading");
    loadingTarget.classList.toggle("btn--loading", isLoading);
    button.disabled = isLoading;
    button.setAttribute("aria-busy", isLoading ? "true" : "false");
  }

  function handleSubmit(evt) {
    if (!evt.target || !evt.target.closest) return;
    var form = evt.target.closest(".product-single__form[data-cart-sku-update='1']");
    if (!form) return;

    evt.preventDefault();
    evt.stopPropagation();
    evt.stopImmediatePropagation();

    var item = getCartItem(form.dataset.cartLineKey) || activeItem;
    var variantInput = form.querySelector('[name="id"]');
    var variantId = variantInput && variantInput.value;
    var button = getSubmitButton(form);

    if (!item || !variantId || !button) return;
    if (form.dataset.cartSkuUpdating === "1") return;

    if (String(variantId) === String(item.variantId)) {
      closeModal(item.productId);
      return;
    }

    form.dataset.cartSkuUpdating = "1";
    setSubmitLoading(button, true);

    var oldVariantId = item.variantId;

     fetchJson("/cart/add.js", buildAddPayload(item, variantId))
      .then(function () {
        return fetch('/cart.js', {
          credentials: "same-origin",
          headers: {
            "X-Requested-With": "XMLHttpRequest"
          }
        });
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var oldItem = cart.items.find(function (cartItem) {
          return String(cartItem.variant_id) === String(oldVariantId);
        });

        if (!oldItem) {
          throw new Error("Unable to find the previous SKU in cart");
        }

        return fetchJson("/cart/change.js", {
          id: oldItem.key,
          quantity: 0
        });
      })
      .then(function () {
        closeModal(item.productId);
        window.location.reload();
      })
      .catch(function (error) {
        var message = error && (error.description || error.message) ? (error.description || error.message) : "Unable to update this item";
        // showFormError(form, message);
        delete form.dataset.cartSkuUpdating;
        setSubmitLoading(button, false);
      });
  }

  document.addEventListener("click", function (evt) {
    if (!evt.target || !evt.target.closest) return;
    var trigger = evt.target.closest("#CartPageForm .cart__variant-meta.sku_item_box");
    if (!trigger) return;

    var item = getCartItem(trigger.dataset.lineKey);
    if (!item) return;

    evt.preventDefault();
    evt.stopPropagation();
    evt.stopImmediatePropagation();

    openModal(item, trigger);
  }, true);

  document.addEventListener("submit", handleSubmit, true);

  document.addEventListener("quickview:open", function (evt) {
    var productId = evt.detail && evt.detail.productId;
    if (!activeItem || String(activeItem.productId) !== String(productId)) return;

    var modal = getModal(productId);
    if (modal) {
      configureCartUpdateModal(modal, activeItem);
    }
  });
})();
